import { jsx as _jsx } from "react/jsx-runtime";
import { StyledBackwardButton } from "./BackwardButton.styles";
export const BackwardButton = (props) => _jsx(StyledBackwardButton, Object.assign({}, props));
